import React from 'react';
import { IQueryResult, IProductCatalogQueryParams, IProductCatalogItem } from 'gen/ApiClient';
import { IQueryContext } from 'framework/context/IQueryContext';

export const QueryContext = React.createContext<IQueryContext<IQueryResult<IProductCatalogItem>, IProductCatalogQueryParams>>(undefined as any);
